export default {
}



// WEBPACK FOOTER //
// ./src/store/cadastro/actions.js